import React, { useState } from "react";
import DashboardLayout from "app/layout/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/layout/DashboardNavbar";
import MDBox from "shared/components/MDBox";
import TableReaders from "./components/TableReaders";

const Readers = () => {
  const [refreshFlag, setRefreshFlag] = useState(false);

  const handleUserCreated = () => {
    setRefreshFlag((prev) => !prev);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mb={0} />

      <MDBox mt={2} mb={0}>
        <TableReaders refreshFlag={refreshFlag} />
      </MDBox>
    </DashboardLayout>
  );
};

export default Readers;
